import { api } from '@shared/web/api-client';
import type { AuthState } from '@shared/web/types';

/** Every auth HTTP call the client makes. */
export const authApi = {
  me: () => api.get<AuthState>('/auth/me'),
  logout: () => api.post<{ ok: true }>('/auth/logout'),
  /** Full-page navigation — OAuth cannot happen over fetch. */
  startGoogleLogin: () => {
    window.location.href = '/auth/google';
  },
};
